<template>
  <v-container fluid grid-list-md text-xs-center class="pt-0 pb-0">
    <v-card class="pa-2 mb-3 card-r pb-4 grey lighten-4 shadow-1">
      <v-toolbar class="primary mb-3 card-r pl-3 text-white">
        <router-link to="/customers"><v-icon class="text-white mr-3 left">arrow_left</v-icon></router-link>
        <div class="text-xs-left f-20">Edit : {{ customerDetail.club_name }}</div>
      </v-toolbar>
       <v-form v-model="EditClub">
              <v-container grid-list-md class="pt-0 pa-0 pb-0">
                <v-layout wrap>
                  <v-flex xs12>
                    <div class="text-xs-center left">
                      <!-- <v-chip color="primary"  text-color="white">Club Details</v-chip> -->
                      <div class="f-15 font-weight-bold">Club Details</div>
                    </div>
                  </v-flex>
                  <v-flex xs12 lg4>
                    <v-text-field
                      required
                      color="#749DBF"
                      type="text"
                      placeholder="CVR"
                      class="textFeald"
                      solo
                      label="CVR Number"
                      prefix="DK"
                      v-model="customerDetail.cvr_number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 lg4>
                    <v-text-field
                      required
                      color="#749DBF"
                      type="text"
                      placeholder="School Name"
                      class="textFeald"
                      solo
                      label="School Name"
                      v-model="customerDetail.club_name"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 lg4>
                    <v-text-field
                      required
                      color="#749DBF"
                      class="textFeald"
                      solo
                      type="number"
                      label="Phone Number"
                      placeholder="Phone Number"
                      prefix="+45"
                      :rules="[ v => v.length == 8 || '8 characters']"
                      v-model="customerDetail.club_phone"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 lg12>
                    <v-flex xs12 class="card-r white shadow-1 mb-2">
                      <vue-dawa
                        color="#749DBF"
                        @select="selectItem($event, 'address')"
                        :val="address.oneLineAddress"
                        :showMax="5"
                        placeholder="Address"
                        containerId="your-container"
                        fieldId="your-field-id"
                        fieldName="Address"
                        solo
                      >
                        <!--<label slot="label-top" for="field-2">Address</label>-->
                      </vue-dawa>
                    </v-flex>
                  </v-flex>
                  <v-flex xs12 lg4>
                    <v-text-field
                      required
                      color="#749DBF"
                      type="text"
                      placeholder="Email"
                      class="textFeald"
                      solo
                      label="Email"
                      v-model="customerDetail.club_email"
                      @click="emailchange=true"
                    ></v-text-field>
                    <v-chip label v-model="emailchange" outline color="red">email confirmation is required when you change email field</v-chip>

                  </v-flex>
                  <v-flex xs12 lg4>
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field solo
                          label="Start Date"
                          v-model="customerDetail.start_date"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        v-model="date"
                        :max="new Date().toISOString().substr(0, 15)"
                        min="1950-01-01"
                        @change="save(date)"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <!--<v-flex xs12 lg6>-->
                    <!--<v-dialog-->
                      <!--ref="modal"-->
                      <!--v-model="modal"-->
                      <!--:return-value.sync="customerDetail.start_date"-->
                      <!--persistent-->
                      <!--lazy-->
                      <!--full-width-->
                      <!--width="290px"-->
                    <!--&gt;-->
                      <!--<v-text-field-->
                        <!--slot="activator"-->
                        <!--v-model="customerDetail.start_date"-->
                        <!--label="Start date"-->
                        <!--readonly-->
                      <!--&gt;</v-text-field>-->
                      <!--<v-date-picker-->
                        <!--v-model="customerDetail.start_date"-->
                        <!--scrollable-->
                        <!--@input="$refs.modal.save(customerDetail.start_date)"-->
                      <!--&gt;</v-date-picker>-->
                    <!--</v-dialog>-->
                  <!--</v-flex>-->
                  <!-- <v-flex xs16>
                    <v-text-field
                      required
                      color="#749DBF"
                      type="text"
                      placeholder="Address"
                      class="textFeald"
                      solo
                      label="Address"
                      v-model="address"
                    ></v-text-field>
                  </v-flex>-->



                  <!-- <v-flex xs16>
                    <v-text-field
                      required
                      color="#749DBF"
                      type="text"
                      placeholder="Open Time"
                      class="textFeald"
                      solo
                      label="Open Time"
                      v-model="customerDetail.club_start_time"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs16>
                    <v-text-field
                      required
                      color="#749DBF"
                      type="text"
                      placeholder="Close Time"
                      cd
                      class="textFeald"
                      solo
                      label="Close Time"
                      v-model="customerDetail.club_end_time"
                    ></v-text-field>
                  </v-flex> -->
                  <v-flex xs12 lg4>
                    <v-text-field
                      required
                      color="#749DBF"
                      type="text"
                      placeholder="Description"
                      class="Description"
                      solo
                      label="Description"
                      v-model="customerDetail.description"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 lg12>
                    <v-text-field
                      required
                      color="#749DBF"
                      type="text"
                      placeholder="Benefits"
                      class="Benefit"
                      solo
                      label="Benefits"
                      v-model="customerDetail.benefit"
                    ></v-text-field>
                  </v-flex>

                  <!--<v-flex xs16>-->
                    <!--<v-text-field-->
                      <!--required-->
                      <!--color="#749DBF"-->
                      <!--type="text"-->
                      <!--placeholder="Email"-->

                      <!--class="textFeald"-->
                      <!--solo-->
                      <!--label="Email"-->
                      <!--v-model="customerDetail.club_email"-->
                    <!--&gt;</v-text-field>-->
                  <!--</v-flex>-->
                  <v-flex md12 sm12 xs12 class="">
                    <v-flex md12 sm12 xs12 class="white shadow-1">
                        <open-days v-on:setDaysAndTime="setDaysAndTime" v-bind:Data="opendays"/>
                    </v-flex>
                  </v-flex>

                  <v-flex xs12>
                    <div class="text-xs-center left">
                      <div class="f-15 font-weight-bold">Contact Details</div>
                    </div>
                  </v-flex>

                  <v-flex xs12 lg4>
                    <v-text-field
                      required
                      color="#749DBF"
                      type="text"
                      placeholder="User Name"
                      class="textFeald"
                      solo
                      label="Full Name"
                      v-model="customerDetail.user.name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 lg4>
                    <v-text-field
                      required
                      color="#749DBF"
                      class="textFeald"
                      solo
                      type="number"
                      label="Phone Number"
                      placeholder="Phone Number"
                      prefix="+45"
                      :rules="[ v => v.length >= 8 || 'Min 8 characters']"
                      v-model="customerDetail.user.phone"
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs3>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="menu2"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="100px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="date"
                        label="Date of Birth"
                        placeholder="Birthday"
                        solo
                        readonly
                        required
                      ></v-text-field>
                      <v-date-picker no-title v-model="date" @input="menu2 = false"></v-date-picker>
                    </v-menu>
                  </v-flex>-->
                  <v-flex xs6 lg4>
                    <v-select
                      color="#749DBF"
                      v-model="customerDetail.user.gender"
                      :items="gender_"
                      label="Gender"
                      required
                      solo
                      placeholder="Gender"
                    ></v-select>
                  </v-flex>

                  <!-- <v-flex xs12>
                    <v-text-field
                      required
                      color="#749DBF"
                      class="textFeald"
                      solo
                      label="Discription"
                      placeholder="Discription"
                      v-model="discription"
                      multi-line
                    ></v-text-field>
                  </v-flex>-->
                  <!-- <v-flex xs6>
                    <v-text-field
                      required
                      color="#749DBF"
                      class="textFeald"
                      solo
                      label="Address"
                      placeholder="Address"
                      v-model="address"
                    ></v-text-field>
                  </v-flex>-->
                  <v-flex xs12 lg4>
                    <v-flex xs12 class="card-r white shadow-1">
                      <vue-dawa
                        color="#749DBF"
                        @select="selectItem($event, 'useraddress')"
                        :val="useraddress.oneLineAddress"
                        :showMax="5"
                        placeholder="Address"
                        containerId="your-container"
                        fieldId="your-field-id"
                        fieldName="Address"
                        solo
                      >
                        <!--<label slot="label-top" for="field-2">Address</label>-->
                      </vue-dawa>
                    </v-flex>
                  </v-flex>
                  <v-flex xs12 lg4>
                    <v-select solo
                      v-model="customerDetail.admin_package_id"
                      :items="package_"
                      disabled
                      attach

                      chips
                      placeholder
                      label="Package"
                      item-value="id"
                      item-text="name"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 lg4>
                    <v-text-field
                      required
                      color="#749DBF"
                      class="textFeald"
                      solo
                      label="Email"
                      placeholder="Email"

                      v-model="customerDetail.user.email"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary card-r no-shadow" dark @click="onSignup">Update</v-btn>
              </v-card-actions>
            </v-card-actions>
          </v-form>
      <!--</v-card>-->
      <!-- <notifications group="error" position="top center"/>
      <notifications group="success" position="bottom center"/>-->
    </v-card>
    </v-container>
</template>

<script>
/* eslint-disable */
import VueDawa from "vue-dawa";
import OpenDays from "./EditOpenDays.vue";

export default {
  props: ["id"],
  name: "EditCustomer",
  data: () => ({
    demoValue:'',
    menu: false,
    emailchange: false,
    customerDetail: [],
    ClubView: null,
    passwordShow: false,
    EditClub: false,
    date: null,
    birthday: false,
    Membershipdata: null,
    Package_type: [],
    package_: [],
    gender_: ["male", "female","non-binary"],
    schoolName: "",
    name: "",
    phone: "",
    club_number: "",
    gender: "",
    state: "",
    city: "",
    discription: "",
    // Address mean ClubAddress
    address: {
      oneLineAddress: "",
    },
    useraddress: {
      oneLineAddress: "",
    },
    adminpassword: "",
    adminemail: "",
    zip: "",
    cancel_time: null,
    cancel_time_: ["01:00:00", "02:00:00", "05:00:00", "12:00:00", "24:00:00"],
    commission: "",
    package_: [],
    memberShipID: [],
    opendays:[],
    passwordRule: [
      v => !!v || "Password is required",
      v => v.length >= 8 || "Password must be more than 8 characters"
    ],
    phoneRule: [
      v => !!v || "Phone Number is required",
      v => v.length <= 8 || "Minimum 8 Digits number"
    ]
  }),
  // beforeCreate(){
  // // },
  beforeDestroy() {
    // this.$store.state.ViweClubDetail=null
  },
  mounted() {
    // this.setAddress();
  },
  updated: function() {
  },
  created() {
    Store.dispatch("loadAdminPackages");
    this.package_ = Store.state.adminpackages;

    var id=this.$route.params.id
      Store.dispatch("getCustomerById",id)
    setTimeout(() => {
      this.customerDetail = Store.state.customer;
      this.opendays=this.customerDetail.opendays
      this.setAddress();
      this.customerDetail = Store.state.customer;
    }, 2200);
  },
  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  methods: {
    pushToCustomer() {
      if (this.$store.state.ViweClubDetail == null) {
        this.$router.push("../customers");
        this.$notify({
          group: "error",
          type: "error",
          text: "Error"
        });
      }
    },
    save (date) {
      this.$refs.menu.save(date)
    },
    setDaysAndTime(Data){
      this.customerDetail.opendays=Data.Days
      this.customerDetail.club_start_time=Data.startTime
      this.customerDetail.club_end_time=Data.closeTime
    },
    setDate(date) {
      this.customerDetail.user.dob = date;
    },
    // getclubData(id){
    //         this.$store.dispatch('viewClub',id)
    //         .then(res=>{

    //         },error=>{
    //             this.$notify({
    //                 group: "error",
    //                 type: "error",
    //                 text: error
    //       });

    //         })
    //     },
    onSignup() {
      var admin_id = this.customerDetail.user.id;
      var club_id = this.customerDetail.id;

      // this.customerDetail.user.name=this.CheckNullValue(this.customerDetail.user.name)
      // this.customerDetail.user.email=this.CheckNullValue(this.customerDetail.user.email)
      // this.customerDetail.user.phone=this.CheckNullValue(this.customerDetail.user.phone)
      // this.customerDetail.user.gender=this.CheckNullValue(this.customerDetail.user.gender.toLowerCase())
      // this.customerDetail.admin_package_id=this.CheckNullValue(this.customerDetail.admin_package_id)
      if(this.customerDetail.user.gender=="non-binary"){
        this.customerDetail.user.gender="non_binary"
      }
      var adminData = {
        // name: this.name,
        // email: this.adminemail,
        // phone: this.phone,
        // dob: this.date,
        // address: this.address,
        // city: this.city,
        // state: this.state,
        // zip: this.zip,
        // gender: this.gender.toLowerCase()
        name: this.customerDetail.user.name,
        email: this.customerDetail.user.email,
        phone: this.customerDetail.user.phone,
        floor: this.useraddress.floor,
        street: this.useraddress.street,
        streetNumber: this.useraddress.streetNumber,
        city: this.useraddress.city,
        zip: this.useraddress.zipCode,
        gender: this.customerDetail.user.gender.toLowerCase(),
        package: this.customerDetail.admin_package_id,
        dob: this.$store.state.user.dob,
      };
      this.getMembershipID();
      // if(this.customerDetail.admin_package_id==null){
      //   this.customerDetail.admin_package_id="null"
      // }
      this.$store.dispatch("adminEdit", { adminData, admin_id }).then(
        response => {
          var ClubData = {
            cvr_number:this.customerDetail.cvr_number,
            club_name: this.customerDetail.club_name,
            club_phone: this.customerDetail.club_phone,
            admin_id: admin_id,
            start_date: this.customerDetail.start_date,
            club_email: this.customerDetail.club_email,
            floor: this.address.floor,
            street: this.address.street,
            streetNumber: this.address.streetNumber,
            city: this.address.city,
            zip: this.address.zipCode,
            description: this.customerDetail.description,
            benefit: this.customerDetail.benefit,
            membership_id: this.memberShipID, /////Check this field with backend
            admin_package_id: this.customerDetail.admin_package_id,
            cancellation_time_period: this.customerDetail
              .cancellation_time_period,
            // start_date: this.customerDetail.start_date,
            // start_date: "2020-12-01",
            opendays:['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'],
            club_start_time:this.customerDetail.club_start_time,
            club_end_time:this.customerDetail.club_end_time,
          };

          this.$store.dispatch("clubEdit", { ClubData, club_id }).then(
            clubRes => {
              // this.$notify({
              //   group: "success",
              //   type: "success",
              //   text: "update Success"
              // });
          setTimeout(() => {
            this.$router.push("../customers");
          }, 2000);

            },
            error => {
              this.$notify({
                group: "error",
                type: "error",
                text: error.message
              });
            }
          );
        },
        error => {
          this.$notify({
            group: "error",
            type: "error",
            text: error.message
          });
        }
      );
    },
    CheckNullValue(val){
      if(val==null){
        return ""
      }else{
        return val
      }
    },
    getpackage() {
      //   this.$store.dispatch('getPackage').then(res=>{
      //   this.Membershipdata = res.data
      //   for(let key in this.Membershipdata){
      //     this.package_.push(this.Membershipdata[key].name )
      //   }
      // },error=>{

      // })
      this.package_ = this.$store.state.adminpackages;
    },
    getMembershipID() {
      for (let i = 0; i < this.Package_type.length; i++) {
        for (let a = 0; a < this.Membershipdata.length; a++) {
          if (this.Package_type[i] == this.Membershipdata[a].name) {
            this.memberShipID.push(this.Membershipdata[a].id);
          }
        }
      }
    },
    getPackageName(data) {
      var packagename = [];
      for (let i = 0; i < data.length; i++) {
        for (let key in this.Membershipdata) {
          if (data[i] == this.Membershipdata[key].id) {
            packagename.push(this.Membershipdata[key].name);
          }
        }
      }
      return packagename;
    },
    // here the event payload is of the type "adresse"
    translateData(address) {
      if (!address || !address.data) {
        return;
      }
      return {
        id: address.data.id,
        street: address.data.vejnavn,
        streetNumber: address.data.husnr,
        floor: address.data.etage,
        door: address.data.dør,
        zipCode: address.data.postnr,
        city: address.data.postnrnavn,
        oneLineAddress: address.tekst
      };
    },
    addressNullCheck(address){
        if(address==null || address=="null" || address=="undefined"){
          return ""
        }else{
          return address
        }
    },
    setAddress() {
      this.address.street = this.customerDetail.street;
      this.address.streetNumber = this.customerDetail.streetNumber;
      this.address.floor = this.customerDetail.floor;
      this.address.door = this.customerDetail.door;
      this.address.zipCode = this.customerDetail.zipCode;
      this.address.city = this.customerDetail.city;
      this.address.oneLineAddress =
        this.addressNullCheck(this.customerDetail.street) +
        " " +
        this.addressNullCheck(this.customerDetail.streetNumber) +
        " " +
        this.addressNullCheck(this.customerDetail.floor) +
        " " +
        this.addressNullCheck(this.customerDetail.door) +
        " " +
        this.addressNullCheck(this.customerDetail.zipCode) +
        " " +
        this.addressNullCheck(this.customerDetail.city);

      this.useraddress.street = this.customerDetail.user.street;
      this.useraddress.streetNumber = this.customerDetail.user.streetNumber;
      this.useraddress.floor = this.customerDetail.user.floor;
      this.useraddress.door = this.customerDetail.user.door;
      this.useraddress.zipCode = this.customerDetail.user.zipCode;
      this.useraddress.city = this.customerDetail.user.city;
      this.useraddress.oneLineAddress =
        this.addressNullCheck(this.customerDetail.user.street )+
        " " +
        this.addressNullCheck(this.customerDetail.user.streetNumber) +
        " " +
        this.addressNullCheck(this.customerDetail.user.floor) +
        " " +
        this.addressNullCheck(this.customerDetail.user.door) +
        " " +
        this.addressNullCheck(this.customerDetail.user.zipCode) +
        " " +
        this.addressNullCheck(this.customerDetail.user.city);
    },
    selectItem(payload, objectName) {
      this.$set(this, objectName, this.translateData(payload));

    }
  },
  computed: {
    loading() {
      // return this.$store.getters.loading
    },
    getpackages() {
      this.package_ = this.$store.state.state.adminpackages;
    }
  },
  components: {
    VueDawa,
    OpenDays

  }
};
</script>



// WEBPACK FOOTER //
// src/pages/pages/customers/EditCustomer.vue